module.exports = __webpack_public_path__ + "static/media/447782159_780317107558834_5235459340308233987_n.b29d13ab.jpg";